import src from "IMAGE";
export default { src, width: 283, height: 296, blurWidth: 0, blurHeight: 0};
